<template>
  <div>
    <div class="float-right mt-0">
        <div id="scoreTimeProgressPopup" class="scoreTimeProgressPopup"></div>
        <b-button class="ace_sec_txt settings_btn" id="scoreTimeProgressSetting" :cursor="'pointer'" aria-label="show report settings">
          <span class="fas fa-cog"></span>
        </b-button>
        <b-popover ref="popover" target="scoreTimeProgressSetting" container="scoreTimeProgressPopup" @hide="hide" @show="show" triggers="click" placement="left" class="report_settings_popup" style="top: -30px;">
            <div class="title">
              {{ title }}
            </div>
            <div class="content-section">
                <b-form-group>
                    <b-form-checkbox-group plain stacked v-model="selected">
                        <b-form-checkbox class="ace_sec_txt" value="score" :disabled="disabled('score')"><span class="check-description" id="reportScore">Score (knowledge check score)</span></b-form-checkbox>
                        <b-form-checkbox class="ace_sec_txt" value="time" :disabled="disabled('time')"><span id="reportKcTime" class="check-description">KC Time (time taken for knowledge check)</span></b-form-checkbox>
                        <b-form-checkbox class="ace_sec_txt" value="resourceTime" :disabled="disabled('resourceTime')"><span id="reportResourceTime" class="check-description">Resource Time (time taken to study resource)</span></b-form-checkbox>
                        <b-form-checkbox class="ace_sec_txt" v-if="!isRemoveProgessCheckbox" value="progress" :disabled="disabled('progress')"><span id="scoreProgress" class="check-description">Progress (# of competencies completed)</span></b-form-checkbox>
                        <b-form-checkbox class="ace_sec_txt last-acitivity-row" v-if="isCourseReport" value="lastActivity"><span id="reportLastActivity" class="check-description">Last Activity</span></b-form-checkbox>
                    </b-form-checkbox-group>
                </b-form-group>
                <div class="action-btn">
                    <b-button v-on:click="ok" class="btn button-primary next float-right" aria-label="ok"> ok </b-button>
                </div>
            </div>
        </b-popover>
    </div>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'
  export default {
    name: 'scoreTimeProgress',
    props: ['title', 'isCourseReport', 'isRemoveProgessCheckbox'],
    data: () => {
      return {
        selected: ['score'],
        isOkClicked: false,
        isProgessCheckboxRemoved: false
      }
    },

    methods: {
      ...mapActions([
        'loadLogDashboardActivity'
      ]),

      disabled (label) {
        if (this.selected.indexOf('lastActivity') !== -1) {
          return (this.selected.length === 2) && (this.selected.indexOf(label) !== -1)
        } else {
          return (this.selected.length === 1) && (this.selected[0] === label)
        }
      },

      ok () {
        this.isOkClicked = true
        const modified = this.selected.slice(0)
        if (this.isProgessCheckboxRemoved) {
          modified.push('progress')
        }
        this.$emit('clicked', modified)
        this.$refs.popover.$emit('close')
      },

      hide (bvEvent) {
        if (!this.isOkClicked) {
          bvEvent.preventDefault()
        }
      },

      show () {
        this.loadLogDashboardActivity({action: 'clickCourseReportSettings', page: 'courseReport', link: '', entityUuid: this.courseId})
        this.isOkClicked = false
      }
    },

    watch: {
      isRemoveProgessCheckbox (value) {
        if (value) {
          const index = this.selected.indexOf('progress')
          if (index !== -1) {
            this.selected.splice(index, 1)
            this.isProgessCheckboxRemoved = true
          }
        } else if (this.isProgessCheckboxRemoved) {
          this.selected.push('progress')
          this.isProgessCheckboxRemoved = false
        }
      }
    }
  }
</script>


<style scoped>
  .bs-popover-left {
    border-radius: 0;
    top: -40px important;
    left: 0px important;
  }
  .bs-popover-left .arrow {
    top: 58px important;
  }
  .form-check {
    padding: 11px 23px;
    font-size: 15px;
  }

  .check-input {
    width:15px;
    height:15px;
  }

  .form-check .form-check-description {
    margin-left: 4px;
  }

  .check-description {
    font-size: 16px;
    margin-left: 6px;
  }
  .title {
    font-size: 18px!important;
    text-align: center;
  }

  .content-section {
    max-width: 450px;
    margin-top: 5px;
    padding: 0 22px;
  }
  .form-check .form-check-input {
  margin-top: 3px !important;
  margin-right: 0px !important;
  }
  .form-check-label {
    font-size: 15px;
  }
  .settings_btn, .settings_btn:hover, .settings_btn:focus {
    background: transparent;
  }
  .fa-cog {
    font-size: 28px;
    cursor:pointer;
  }

  .form-group {
    margin-bottom:0;
  }

  .title {
    background: #f5f5f5;
    padding: 10px 0;
  }

  .action-btn {
    margin: 21px 11px 32px 0;
    float: right;
  }

</style>



// WEBPACK FOOTER //
// src/app/course/components/ScoreTimeProgress.vue